import { render } from "./CustomerEdit.html?vue&type=template&id=673d0a98&scoped=true&ts=true"
import script from "./CustomerEdit.ts?vue&type=script&lang=ts"
export * from "./CustomerEdit.ts?vue&type=script&lang=ts"

import "./CustomerEdit.css?vue&type=style&index=0&id=673d0a98&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673d0a98"]])

export default __exports__